import { NextPageContext } from "next";
import { Gender } from "src/modules/page";
import { SalesLandingViewSelectedBrands } from "src/organisms/SalesLandingViewSelectedBrands";
import SalesLandingLayout from "src/Layouts/SalesLandingLayout";
import SalesLandingView from "src/organisms/SalesLandingView/SalesLandingView";
import { SingleSalesLanding } from "src/types/graphql.d";
import { useRouter } from "next/router";
import { isIncludedInSelectedBrands } from "src/utils/selectedBrands";
import Error from "pages/_error";

interface CustomData {
  salesLanding: SingleSalesLanding;
  genderId: Gender;
  isNotFound?: boolean;
}

interface Props {
  salesLanding: SingleSalesLanding;
  genderId: Gender;
  notFound?: boolean;
}

function SalesLanding({
  pageProps: { salesLanding, genderId, notFound },
}: {
  pageProps: Props;
}): JSX.Element {
  const router = useRouter();
  const {
    query: { design, slug },
  } = router;
  const brandSlug = Array.isArray(slug) ? slug[0] : slug;

  if (notFound) {
    return <Error />;
  }

  return isIncludedInSelectedBrands(router.asPath) ? (
    design === "1" ? (
      <SalesLandingView salesLanding={salesLanding} genderId={genderId} />
    ) : (
      <SalesLandingViewSelectedBrands
        salesLanding={salesLanding}
        genderId={genderId}
        brandSlug={brandSlug}
      />
    )
  ) : (
    <SalesLandingView salesLanding={salesLanding} genderId={genderId} />
  );
}

/**
 * NOTE: Redirect to this page CAN NOT use regular NextJS client redirect. Because 'getInitialProps'
 * expects 'req.customData' to be provided from 'outlet.js' middleware of 'server.js'
 *
 * Use:
 * - window.location.assign() - runs 'outlet.js' server middleware. It passes 'customData' OR returns
 * Redis cache that skips 'getInitialProps'
 * - shallow (!) NextJS client redirect - skips 'getInitialProps'
 */
SalesLanding.getInitialProps = (context: NextPageContext) => {
  const { salesLanding, genderId, isNotFound }: CustomData =
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    (context.req?.customData as CustomData) || {};

  if (isNotFound) {
    if (context.res) {
      context.res.statusCode = 404;
    }
    return { notFound: true };
  }

  return {
    salesLanding,
    genderId,
  };
};

SalesLanding.Layout = SalesLandingLayout;

export default SalesLanding;
